var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useReducer } from 'react';
export var NoteIssueActions;
(function (NoteIssueActions) {
    NoteIssueActions[NoteIssueActions["SET_ACTIVE_APPOINTMENT"] = 0] = "SET_ACTIVE_APPOINTMENT";
})(NoteIssueActions || (NoteIssueActions = {}));
var initialState = { activeAppointment: null };
var NoteIssueContext = React.createContext({
    state: initialState,
    dispatch: function () { return null; },
});
export var NoteIssueProvider = function (_a) {
    var children = _a.children;
    var _b = useReducer(function (state, action) {
        switch (action.type) {
            case NoteIssueActions.SET_ACTIVE_APPOINTMENT: {
                return __assign(__assign({}, state), { activeAppointment: action.payload });
            }
            default:
                throw new Error('Invalid action');
        }
    }, initialState), state = _b[0], dispatch = _b[1];
    return (_jsx(NoteIssueContext.Provider, __assign({ value: { state: state, dispatch: dispatch } }, { children: children })));
};
export var useNoteIssueContext = function () {
    var context = React.useContext(NoteIssueContext);
    var dispatch = context.dispatch;
    if (context === undefined) {
        throw new Error('useNoteIssueContext must be used within a NoteIssueProvider');
    }
    var setActiveAppointment = function (payload) {
        dispatch({ type: NoteIssueActions.SET_ACTIVE_APPOINTMENT, payload: payload });
    };
    return __assign(__assign(__assign({}, context), context.state), { setActiveAppointment: setActiveAppointment });
};
